import { useState } from 'react'
import { leases as leaseApi } from '@/api/endpoints'
import type { Lease } from '@/api/types'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Err } from '@/components/Err'
import { CHIP } from './vm/chips'

// 키 재발급 칩(#226). 게이트웨이의 게스트 키가 VM 안에서 지워졌거나 키 파일을 잃었을 때의 최후 수단이다 —
// 기계의 키 쌍을 새로 만들고 VM 의 authorized_keys 를 있어야 할 전체 집합으로 덮어쓴다(손으로 넣은 줄은 사라진다).
// 그래서 제목 하나와 버튼 둘의 대화 상자를 거친다. 실행 중인 기계가 있는 사용 중 임대에만 보이고,
// 끝나면 임대를 다시 읽어 `키 받기` 가 다시 나타난다. 사용자 상세와 관리자 VM 상세가 같은 칩을 쓴다.

export function KeyRotateChip({ lease: l, onChanged }: { lease: Lease; onChanged: () => void }) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  if (l.state !== 'active' || l.vm?.state !== 'running') return null
  const rotate = async () => {
    setBusy(true)
    setError(null)
    try {
      await leaseApi.rotateKey(l.id)
      setOpen(false)
      onChanged()
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }
  return (
    <>
      <button type="button" className={CHIP} onClick={() => (setError(null), setOpen(true))}>
        키 재발급
      </button>
      <Dialog open={open} onOpenChange={(v) => (v || busy ? undefined : setOpen(false))}>
        <DialogContent aria-describedby={undefined} className="sm:max-w-sm">
          <DialogHeader>
            <DialogTitle>{l.name} 키 재발급</DialogTitle>
          </DialogHeader>
          <p className="text-[12px] text-muted-foreground">지금 쓰는 키 파일로는 더 접속할 수 없게 됩니다.</p>
          <Err error={error} />
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => setOpen(false)} disabled={busy}>
              취소
            </Button>
            <Button type="button" onClick={rotate} disabled={busy}>
              {busy ? '재발급 중' : '재발급'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
